import React from 'react';
import classNames from 'classnames';

/**
 * IndeterminateProgressBar
 */
export const IndeterminateProgressBar: React.FC<Readonly<{
    isLoading: boolean;
    className?: string;
    minDuration?: number;
    height?: number;
}>> = props => {

    const [isLoading, setLoading] = React.useState(props.isLoading);

    const timer = React.useRef<number>(null);
    const started = React.useRef<number>(Date.now());
    const minDuraton = props.minDuration ?? 500;

    // Effect
    React.useEffect(() => {
        if (props.isLoading) {
            started.current = Date.now();
            setLoading(true);
            clearTimeout(timer.current);

            timer.current = window.setTimeout(() => {
                setLoading(false);
                timer.current = null;
            }, minDuraton)
        }
        else {
            const delta = Date.now() - started.current + minDuraton;

            if (delta > 0) {
                clearTimeout(timer.current);
                timer.current = window.setTimeout(() => {
                    setLoading(false);
                    timer.current = null;
                }, delta)
            }
            else {
                setLoading(false);
            }
        }

        return () => {
            clearTimeout(timer.current);
        }

    }, [props.isLoading]);

    if (!isLoading) return null;

    // --

    return (
        <div className={classNames("indeterminate-progress-bar uk-position-relative", props.className)} style={{ height: props.height }}>
            <div className="indeterminate-progress-bar__progress"></div>
        </div>
    )
}